import { type ApiEnvelope, api, unwrap } from "@/lib/api";

export type QuoteStatus = "new" | "in_progress" | "quoted" | "won" | "lost";

export interface QuoteItem {
	productId: string;
	slug: string;
	title: string;
	brand: string | null;
	heroImage: string | null;
	qty: number;
}

export interface QuoteRequest {
	id: string;
	reference: string;
	customerName: string;
	customerPhone: string;
	customerEmail: string | null;
	customerCity: string | null;
	message: string | null;
	items: QuoteItem[];
	itemCount: number;
	status: QuoteStatus;
	source: string;
	adminNote: string | null;
	createdAt: string;
	updatedAt: string;
}

export interface QuoteStats {
	total: number;
	new: number;
	in_progress: number;
	quoted: number;
	won: number;
	lost: number;
}

export interface QuoteListResult {
	data: QuoteRequest[];
	total: number;
	page: number;
	pageSize: number;
}

export interface QuoteFilter {
	status?: QuoteStatus;
	q?: string;
	page?: number;
	pageSize?: number;
}

export interface UpdateQuoteInput {
	status?: QuoteStatus;
	adminNote?: string;
}

const toQs = (f: Record<string, unknown>): string => {
	const usp = new URLSearchParams();
	for (const [k, v] of Object.entries(f)) {
		if (v === undefined || v === null || v === "") continue;
		usp.set(k, String(v));
	}
	const qs = usp.toString();
	return qs ? `?${qs}` : "";
};

export const quotesApi = {
	list: (filter: QuoteFilter = {}) =>
		unwrap<QuoteListResult>(
			api.get<ApiEnvelope<QuoteListResult>>(
				`/admin/quote-requests${toQs(filter as Record<string, unknown>)}`,
			),
		),
	stats: () =>
		unwrap<QuoteStats>(
			api.get<ApiEnvelope<QuoteStats>>("/admin/quote-requests/stats"),
		),
	get: (id: string) =>
		unwrap<QuoteRequest>(
			api.get<ApiEnvelope<QuoteRequest>>(`/admin/quote-requests/${id}`),
		),
	update: (id: string, input: UpdateQuoteInput) =>
		unwrap<QuoteRequest>(
			api.patch<ApiEnvelope<QuoteRequest>>(
				`/admin/quote-requests/${id}`,
				input,
			),
		),
};
